import { server } from "../api";
import axios from "axios";

export default {
  PowerOn: async (IP, port, name) => {
    let response = await axios.get(`https://${IP}:${port}/onn`, {
      params: { nodeID: 1, name },
    });
    return response.data;
  },

  PowerOff: async (IP, port, name) => {
    let response = await axios.get(`https://${IP}:${port}/off`, {
      params: { nodeID: 1, name },
    });
    return response.data;
  },

  PowerInit: async (IP, port) => {
    try {
      let response = await axios.get(`https://${IP}:${port}/init_stat?nodeID=1`);
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  PowerGetData: async (IP, port) => {
    try {
      let response = await axios.get(`https://${IP}:${port}/get_stat`);
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  PowerRestart: async () => {
    try {
      const response = await axios.post(server + "power/restart");
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  InitPermissionPassword: async (IP, port, permissionID) => {
    try {
      const response = await axios.get(`https://${IP}:${port}/init_perm?id=${permissionID}`);
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  GetPermissionPassword: async (IP, port, permissionID) => {
    try {
      const response = await axios.get(
        `https://${IP}:${port}/get_perm?permissionID=${permissionID}&port=${port}`);
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  UpdatePermissionPassword: async (IP, port, permissionID, password, field_mobile_id) => {
    try {
      const response = await axios.post(`https://${IP}:${port}/update_perm_pwd`, {
        permissionID: permissionID,
        password: password,
				field_mobile_id: field_mobile_id
      });
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  UpdatePermissionName: async (mobileID, permissionID, name) => {
    try {
      const response = await axios.post(server + "power/update_perm_name", {
        mobileID: mobileID,
        permissionID: permissionID,
        name: name
      });
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  }
};
